<template>
	<div class="flex items-center gap-2 border border-button-secondary-border rounded-full shadow-xs">
		<template v-if="itemsInCart">
			<button
				class="relative group w-11 h-11 flex items-center justify-center rounded-full transition-all duration-150 hover:bg-button-secondary-surface-hover"
				aria-label="Odebrat"
				@click="removeFromShoppingCart"
				@mouseleave="itemsInCart ? canShowRemoveHover = true : canShowRemoveHover = false"
			>
				<span class="sr-only">Odebrat</span>
				<NuxtIcon
					name="minus"
					class="text-icon-primary text-xl transition-opacity duration-150 relative z-10"
				/>
			</button>
			{{ itemsInCart }}
		</template>
		<button
			type="button"
			class="relative group w-11 h-11 flex items-center justify-center rounded-full bg-background-primary border-border-tertiary transition-all duration-150 hover:bg-button-secondary-surface-hover"
			aria-label="Přidat"
			@click="addToShoppingCart"
			@mouseleave="itemsInCart ? canShowRemoveHover = true : canShowRemoveHover = false"
		>
			<span class="sr-only">Přidat</span>
			<NuxtIcon
				name="plus"
				class="text-icon-primary text-xl transition-opacity duration-150 relative z-10"
			/>
		</button>
	</div>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {IncompatiblePickupTimesError, useShoppingCartStore} from '~/stores/shoppingCart';
	import type {OfferResult} from '~/openapi';

	type Props = {product: OfferResult};

	type Emit = {
		(e: 'change', type: string): void;
	};

	const props = defineProps<Props>();
	const emit = defineEmits<Emit>();

	const slug = useMonadicRouteParam('slug');
	const incompatiblePickupTimes = useEventBus<IncompatiblePickupTimesError>('incompatible-pickup-times');
	const canShowRemoveHover = ref<boolean>(false);

	function addToShoppingCart() {
		try {
			shoppingCartStore.add(props.product);
			emit('change', 'add');
			trackCart('add_to_cart');
		} catch (error) {
			if (error instanceof IncompatiblePickupTimesError) {
				incompatiblePickupTimes.emit(error);
			} else {
				throw error;
			}
		}
	}

	function removeFromShoppingCart() {
		shoppingCartStore.remove(props.product);
		emit('change', 'remove');
		trackCart('remove_from_cart');
	}

	const shoppingCartStore = useShoppingCartStore();
	const {itemsById} = storeToRefs(shoppingCartStore);

	const itemsInCart = computed(() => itemsById.value[props.product?.offerId ?? 0]);

	function trackCart(event: string) {
		trackEcommerceEvent(event, {items: mapGoosProductsToGtmEvent([props.product], slug.value)});
	}
</script>
